import React from "react";

const AkamLogoCheck: React.FC = () => (
    <svg
      width="29"
      height="21"
      viewBox="0 0 29 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2263 2.69667C21.5835 3.07 21.5835 3.67528 21.2263 4.04861L7.93525 17.9391C7.57803 18.3124 6.99887 18.3124 6.64165 17.9391L0.998383 12.0413C0.641164 11.668 0.641164 11.0627 0.998382 10.6894L3.26218 8.32351C3.6194 7.95019 4.19856 7.95018 4.55578 8.32351L6.96505 10.8414C7.14366 11.0281 7.43324 11.0281 7.61185 10.8414L17.6689 0.330777C18.0261 -0.0425506 18.6053 -0.0425505 18.9625 0.330777L21.2263 2.69667Z"
        fill="currentColor"
      />
      <foreignObject x="5.13462" y="0.128757" width="25.7991" height="23.2039">
        <div
          // xmlns="http://www.w3.org/1999/xhtml"
          style={{ backdropFilter: 'blur(1.26px)', clipPath: 'url(#bgblur_0_2379_42607_clip_path)', height:'100%', width: "100%" }}
         />
      </foreignObject>
      <path
        data-figma-bg-blur-radius="2.51773"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.1482 5.29237C28.5054 5.6657 28.5054 6.27098 28.1482 6.64431L14.8571 20.5348C14.4999 20.9081 13.9207 20.9081 13.5635 20.5348L7.92026 14.637C7.56304 14.2637 7.56304 13.6584 7.92026 13.2851L10.1841 10.9192C10.5413 10.5459 11.1204 10.5459 11.4777 10.9192L13.8869 13.4371C14.0655 13.6238 14.3551 13.6238 14.5337 13.4371L24.5908 2.92648C24.948 2.55315 25.5272 2.55315 25.8844 2.92648L28.1482 5.29237Z"
        fill="#12B76A"
        fillOpacity="0.75"
      />
      <defs>
        <clipPath
          id="bgblur_0_2379_42607_clip_path"
          transform="translate(-5.13462 -0.128757)"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.1482 5.29237C28.5054 5.6657 28.5054 6.27098 28.1482 6.64431L14.8571 20.5348C14.4999 20.9081 13.9207 20.9081 13.5635 20.5348L7.92026 14.637C7.56304 14.2637 7.56304 13.6584 7.92026 13.2851L10.1841 10.9192C10.5413 10.5459 11.1204 10.5459 11.4777 10.9192L13.8869 13.4371C14.0655 13.6238 14.3551 13.6238 14.5337 13.4371L24.5908 2.92648C24.948 2.55315 25.5272 2.55315 25.8844 2.92648L28.1482 5.29237Z"
          />
        </clipPath>
      </defs>
    </svg>
  );

export default AkamLogoCheck;
